<template>
  <div>
    <!-- 国际运费 -->
    <!-- 选中各箱国际运费参考 -->
    <el-dialog :title="$t('message.internationalFreight')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="1280px" center>
      <div class="content">
        <el-table :data="tableData" border :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%"
          max-height="800">
          <el-table-column label="NO" align="center" type="index"></el-table-column>
          <!-- 发送方式 -->
          <el-table-column property="logistics_name" :label="$t('message.wayToSend')" align="center"></el-table-column>
          <!-- 计费规则 -->
          <el-table-column :label="$t('message.accountingRules')" align="center" width="220">
            <template slot-scope="scope">
              <div class="template">
                <p>
                  计价方式：
                  {{ scope.row.rulePart.chargeFinal == 2 ? "单配送单最终计费" : "单箱计费后累加" }}
                </p>
                <p>
                  计价类型：{{ scope.row.rulePart.chargeMethod == "weight" ? "重量" : "体积" }}
                </p>
                <p>
                  计抛方式：{{ scope.row.rulePart.chargeWhole == "single" ? "单箱" : "整票" }}
                </p>
                <p>抛重比例：{{ scope.row.rulePart.rate }}</p>
              </div>
            </template>
          </el-table-column>
          <!-- 箱数 -->
          <el-table-column property="boxCount" :label="$t('message.boxNum')" align="center"></el-table-column>
          <!-- 合计体积.m³ -->
          <el-table-column property="volume" :label="$t('message.totalVolume') + '.m³'"
            align="center"></el-table-column>
          <!-- 合计实重.kg -->
          <el-table-column property="weight" :label="$t('message.totalRealWeight') + '.kg'"
            align="center"></el-table-column>
          <!-- 计费重量.kg -->
          <el-table-column property="charged_weight" :label="$t('message.BillingWeight')"
            align="center"></el-table-column>
          <!-- 合计抛重.kg -->
          <el-table-column property="volumeWeight" :label="$t('message.totalWeightPao') + '.kg'"
            align="center"></el-table-column>
          <!-- 计费数据 -->
          <el-table-column :label="$t('message.billingData')" align="center" width="200">
            <template slot-scope="scope">
              <div class="template">
                <p>
                  重量体积运费:
                  {{ scope.row.money_detail.weight_volume_money_rmb }}
                </p>
                <p>
                  每箱附加费: {{ scope.row.money_detail.every_box_other_rmb }}
                </p>
                <p>
                  整单附加费:
                  {{ scope.row.money_detail.whole_logistics_other_rmb }}
                </p>
              </div>
            </template>
          </el-table-column>
          <!-- 国际运费.元 -->
          <el-table-column property="total_money_rmb" :label="$t('message.internationalFreight') + '.元'"
            align="center"></el-table-column>
          <!-- 国际运费.円 -->
          <el-table-column property="total_money_rmb" :label="$t('message.internationalFreight') + '.円'" align="center">
            <template slot-scope="scope">
              {{ (scope.row.total_money_rmb * rate).toFixed(0) }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
  props: {
    data: { type: Object }
  },
  data() {
    return {
      weight: "",
      dialogVisible: false,
      boxTotalNum: 0,
      tableData: []
    };
  },
  computed: {
    ...mapState({
      rate: (state) => state.rate,
    })

  },

  methods: {
    predictLogisticsPrice() {
      let datas = {
        datetime: "",
        list: [],
      };
      this.$api.porderApi.predictLogisticsPrice(this.data).then((res) => {
        this.tableData = res.data;
        console.log(res);
      });
    },
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible) {
        this.predictLogisticsPrice();
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;

  h6 {
    background-color: #f6f6f6;
    padding: 10px;
    margin-bottom: 24px;
    border-radius: 5px;

    span {
      font-size: 16px;
      margin-right: 20px;
    }
  }

  .template {
    width: 100%;
    text-align: left;
  }
}
</style>